export default __webpack_public_path__ + "static/media/1803.5d27555c.png";